<div aria-labelledby="gallery-tab" class="tab-pane tab-content fade show active" id="hotelRoomGallery" role="tabpanel">
    <FlashMessage></FlashMessage>
    <div class="container-fluid">
        <div class="content-block">
            <div class="row align-content-center">

                <div class="col-lg-10">
                    <div class="empty-data green my-0">
                        <p>
                            You can browse, add, or edit the images for the gallery of the hotel room.
                        </p>
                    </div>
                </div>
                <div class="col-md-2">
                    <a @click.prevent="onUploadHotelImage('image')" class="btn btn-sm add-btn" data-toggle="modal" href="#"><i
                            class="fas fa-plus"></i>
                        Browse
                    </a>
                    <UploadFile :checkTitle="vars.postdata.checkTitle" :limitdata="vars.limitdata" :postdata="vars.postdata" :shouldfileupload="ui.status.fileupload" :titles="vars.titles" @closeUploadModal="closeUploadModal" @documentUploaded="documentUploaded" v-if="ui.status.fileupload"></UploadFile>
                </div>
            </div>

            <div class="content-block">
                <div class="row">
                    <div :key="index" class="col-lg-2" v-for="(image, index) in item.imageList">
                        <div class="gallery-image-container">
                            <img alt="" onerror="this.onerror=null;this.src='/img/nnn.jpg';" src="img/travel-2.jpg" v-if="!item.imageList" />
                            <img :src="image.image_path" alt="" onerror="this.onerror=null;this.src='img/nnn.jpg';" />
                            <div class="banner-icon" v-if="image.is_banner">
                                <i class="fas fa-check"></i>
                            </div>
                            <div class="overlay">
                                <div class="middle">
                                    <button @click="setBannerImage(index, image)" class="btn btn-success rounded-btn" type="button" v-tooltip.top="{ content: 'Set Package Banner Image', class: 'tooltip-custom tooltip-other-custom' }">
                                        <i class="fas fa-image"></i>
                                    </button>

                                    <button @click.prevent="deleteModal(index, image)" class="btn red" type="button">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>

                                    <p class="text-white" v-if="image.is_banner">(This image is selected as banner image.)
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="spinner">
                        <moon-loader :loading="ui.status.isLoading.getImageList" :size="50" v-if="item.imageList"></moon-loader>
                        <!-- <spinner v-if="IsLoading" :loading="IsLoading"></spinner> -->
                    </div>
                </div>
            </div>
            <!-- Delete Modal -->
            <div class="modal-wrap">
                <div aria-labelledby="exampleModalLabel" class="modal fade show" id="deleteHotelImage" role="dialog" tabindex="-1">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Delete Image</h5>
                                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="error-list" v-if="ui.error.error_message">
                                <ul class="error-msg">
                                    <li :key="x" v-for="(error,x) in ui.error.error_message">
                                        {{ error }}
                                    </li>
                                </ul>
                            </div>
                            <div class="modal-body">
                                <p>
                                    Are you sure you want to delete this ?
                                </p>
                            </div>

                            <div class="modal-footer">
                                <button @click="deleteImage()" class="btn default-btn" type="button">
                                    Ok
                                </button>
                                <button @click.prevent="hidedeleteModal" aria-label="Close" class="btn default-btn cancel" type="button">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>